module.exports = __webpack_public_path__ + "static/media/playstore.562034f0.png";